import { render } from "./CourseCreationPage.vue?vue&type=template&id=33612ee0&scoped=true"
import script from "./CourseCreationPage.vue?vue&type=script&lang=js"
export * from "./CourseCreationPage.vue?vue&type=script&lang=js"

import "./CourseCreationPage.vue?vue&type=style&index=0&id=33612ee0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33612ee0"]])

export default __exports__